import html2canvas, { Options as HTML2CanvasOptions } from 'html2canvas';
import React from 'react';

export function enumToSelectOptions<T extends string>(enumObj: Record<string, T>) {
  return Object.entries(enumObj).map(([key, value]) => ({
    label: key,
    value
  }));
}

export async function htmlText2Canvas(html: string, options: Partial<HTML2CanvasOptions> = {}) {
  const offscreenContainer = document.createElement('div');
  offscreenContainer.innerHTML = html;
  offscreenContainer.style.position = 'absolute';
  offscreenContainer.style.top = '-9999px';
  offscreenContainer.style.left = '-9999px';
  offscreenContainer.style.width = '100%';
  offscreenContainer.style.height = '100%';
  offscreenContainer.style.pointerEvents = 'none';
  document.body.appendChild(offscreenContainer);
  const canvas = await html2canvas(offscreenContainer, {
    useCORS: true,
    allowTaint: true,
    logging: false,
    ...options
  });
  document.body.removeChild(offscreenContainer);
  return canvas;
}

export function normalizeStringForTestId(label: string | undefined) {
  if (!label) {
    return '';
  }

  return `${label.toLowerCase().replaceAll(' ', '-').replaceAll('.', '-')}`;
}

export function getTextFromReactNode(node: React.ReactNode): string {
  if (typeof node === 'string') return node;
  if (typeof node === 'number') return String(node);
  if (!node) return '';

  const parts: string[] = [];
  React.Children.forEach(node, (child) => {
    if (typeof child === 'string' || typeof child === 'number') {
      parts.push(String(child));
    } else if (React.isValidElement(child)) {
      const text = getTextFromReactNode(child.props.children);
      if (text) parts.push(text);
    }
  });

  return parts.join('\n');
}
